<div class="gt-background-blur client-page-full-screen">
  <div>
    <div class="clientPage-header">
      <div class="logo gtw-web-components">
        <div class="a-pwc-logo-grid a-md"></div>
      </div>
      <div class="client-label">
        GTW
      </div>
      <div class="client-label-full-text">
        <span>Global Tax Workspace</span>
      </div>
    </div>
  </div>
  <div class="clientPage-left-nav-bar"></div>

  @if (loading) {
<div class="loading-overlay">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}

  <div class="search-wrapper">
    <div>
      <span class="fa fa-search srch-icn"></span>
      <input type="text"
             class="search-box"
             placeholder="Search"
             [(ngModel)]="searchClient" />
    </div>
  </div>

  <div>
    <div class="cards-container">
      @for (client of filteredClients; track trackByClientKey($index, client)) {
<div class="company-card"
          >
        <div class="card-content" (click)="openClientDetailsModal($event, client)">
          <div class="card-header">
            @if (client.logo_client) {
<img [src]="client.logo_client" class="img-responsive" alt="Client Logo">
}
            <span class="client-name">{{client.CLIENT_NAME}}</span>
          </div>
          <div class="tax-file-status-wraper">
            <div>Extension Filing Date: {{client.EXT_FILING_DATE}}</div>
            <div>Filing Date: {{client.FILING_DATE ? client.FILING_DATE : 'N/A'}}</div>
          </div>
          <div class="bar-wrapper">
            <div>Return Status</div>
            <div class="progress-bar">
              <div class="completed" [style.width.%]="client.PERCENTILE_COMPLETE"></div>
            </div>
          </div>
          <div class="ftr">
            <div class="show-more-wrapper">
              <span class="fa fa-angle-up show-more"
                    (click)="openClientDetailsModal($event, client)">
              </span>
            </div>
            <button class="btn btn-sm launch-btn" type="button"
                    (click)="clientLanding(client.CLIENT_KEY, '/home', 'home', $event)"
                    [disabled]="clientBtnLoader">
              @if (clientBtnLoader && client.CLIENT_KEY == selectedClientKey) {
<span style="margin-right: 3px;">
                <i class="fa fa-spinner fa-pulse"></i>
              </span>
}
              LAUNCH
            </button>
          </div>
        </div>
      </div>
}
    </div>
  </div>
</div>
